import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
};

const setAuctionDetails = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data
    };
};

const setActiveSlider = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        activeSlideIndex: data
    };
};

const HANDLERS = {
    [Types.SET_AUCTION_DETAILS]: setAuctionDetails,
    [Types.SET_ACTIVE_SLIDE_NUMBER]: setActiveSlider
};

export default createReducer(INITIAL_STATE, HANDLERS);